import { Box } from "@chakra-ui/react";
import { NINE, ONE, ZERO } from "utils/constants";

import { COLORS } from "./const";

interface EmptyImagePlaceholderProps {
  initial?: string;
  index: string;
  className?: string;
}
function stringToNumber(input: string | number | null | undefined) {
  if (!input) return ONE;

  const strInput = String(input);
  const sum = Array.from(strInput)
    .filter((char) => /\d/.test(char))
    .map(Number) // Convert to numbers
    .reduce((acc, num) => acc + num, ZERO);

  return (sum % NINE) + ONE;
}

export const EmptyImagePlaceholder = ({
  initial,
  index = `${ZERO}`,
  className,
}: EmptyImagePlaceholderProps) => {
  const backgroundColor = COLORS[stringToNumber(index) % COLORS.length];

  return (
    <Box
      className={className || "w-full h-full rounded-[50%]"}
      style={{ backgroundColor }} // Apply the background color dynamically
    >
      <Box className="flex items-center justify-center h-full text-white uppercase">
        {initial || "O"}
      </Box>
    </Box>
  );
};
